import { Link } from 'react-router-dom';
import type { ComicItem } from '@/mocks/home';

interface PopularRankingProps {
  comics: ComicItem[];
}

export default function PopularRanking({ comics }: PopularRankingProps) {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              热门排行
            </h2>
            <p className="mt-2 text-sm text-foreground-500">读者票选最受欢迎韩漫 TOP 8</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {comics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group flex items-center gap-4 p-4 rounded-xl bg-background-50 hover:bg-background-200/80 transition-all duration-200"
            >
              <div className="relative flex-shrink-0">
                <div className="w-16 h-20 md:w-18 md:h-24 rounded-lg overflow-hidden bg-background-200">
                  <img
                    src={comic.coverImage}
                    alt={`${comic.title} - 韩漫热门排行`}
                    title={`${comic.title} - 韩漫热门排行`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="absolute -top-1.5 -left-1.5 w-5 h-5 md:w-6 md:h-6 rounded-full flex items-center justify-center text-xs font-bold text-background-50 bg-accent-500">
                  {index + 1}
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {comic.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{comic.author}</p>
                <div className="mt-2 flex items-center gap-3">
                  <span className="flex items-center gap-1 text-xs text-primary-600 font-medium">
                    <i className="ri-star-fill w-3 h-3 flex items-center justify-center"></i>
                    {comic.rating}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    {(comic.views / 10000).toFixed(0)}万阅读
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}